import {
   HealthcareProviderAppointmentReminderPatientNotificationConfigurationQuery,
   HealthcareProviderNotificationConfiguration,
} from '@dreryk/egabinet-phone-notification-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';

type PatientPhoneNotificationAppointmentReminderToggleLoaderResult = {
   notificationEnabled: boolean;
   messages: string[];
   refetch: VoidFunction;
};

type PatientPhoneNotificationAppointmentReminderToggleLoaderProps = {
   readonly children: (result: PatientPhoneNotificationAppointmentReminderToggleLoaderResult) => JSX.Element;
};

export const PatientPhoneNotificationAppointmentReminderToggleLoader = (
   props: PatientPhoneNotificationAppointmentReminderToggleLoaderProps
): JSX.Element | null => {
   const {
      data: healthcareProviderNotificationConfiguration,
      loading: healthcareProviderNotificationConfigurationLoading,
      error: healthcareProviderNotificationConfigurationError,
      refetch,
   } = useCqrsGet<HealthcareProviderNotificationConfiguration>(() => {
      return new HealthcareProviderAppointmentReminderPatientNotificationConfigurationQuery();
   });

   if (
      healthcareProviderNotificationConfigurationLoading ||
      healthcareProviderNotificationConfigurationError ||
      !healthcareProviderNotificationConfiguration
   ) {
      return null;
   }

   return props.children({
      notificationEnabled: healthcareProviderNotificationConfiguration.enabled,
      messages: healthcareProviderNotificationConfiguration.messages,
      refetch: refetch,
   });
};
